import { render, staticRenderFns } from "./DocumentosActivosVista.vue?vue&type=template&id=7fc684ca&scoped=true"
import script from "./DocumentosActivosVista.vue?vue&type=script&lang=js"
export * from "./DocumentosActivosVista.vue?vue&type=script&lang=js"
import style0 from "./DocumentosActivosVista.vue?vue&type=style&index=0&id=7fc684ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fc684ca",
  null
  
)

export default component.exports